import React from 'react';
import classNames from 'classnames';
import {useModal} from 'contexts/modal';
import {Button} from 'reactstrap';

export function OptinModalTriggerCL({color = 'cta', size = 'lg', className, btnText, classOverride = false}) {
  const modalProps = useModal();
  return (
    <Button
      color={color}
      size={size}
      className={classNames(
        !classOverride && `btn-size-350 text-uppercase text-white text-condensed text-800`,
        className
      )}
      onClick={modalProps.toggle}
    >
      {btnText ? btnText : 'Join Now'}
    </Button>
  );
}
